import * as React from "react";
const SvgFiRrGrillHotAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-grill-hot-alt_svg__a)">
      <path
        fill="#062147"
        d="M11.04 3V1a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0m5 1a1 1 0 0 0 1-1V1a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1m-8 0a1 1 0 0 0 1-1V1a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1m15.922 5.691c-.73 3.186-2.844 5.97-5.755 7.649l1.781 5.343a1 1 0 1 1-1.896.633L17.653 22H11a1 1 0 1 1 0-2h5.986l-.667-2H7.76l-.557 1.671a2.5 2.5 0 1 1-1.886-.664l.555-1.666C2.96 15.663.845 12.878.115 9.691A3.01 3.01 0 0 1 .696 7.13 2.98 2.98 0 0 1 3.04 6h17.997c.918 0 1.771.412 2.344 1.13a3.01 3.01 0 0 1 .581 2.562zm-2.146-1.315A.98.98 0 0 0 21.037 8H3.04a.98.98 0 0 0-.779.376 1.02 1.02 0 0 0-.196.868c.666 2.909 2.734 5.42 5.553 6.756h8.844c2.817-1.335 4.886-3.847 5.552-6.755.07-.308 0-.624-.196-.869z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-grill-hot-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGrillHotAlt;
